import home from "./pages/home_businessHall" //网上营业厅
import customerCenter from "./pages/customer_center" //客户中心
import businessMenu from "./pages/business_office/menu" //业务办理

import waterFee from "./pages/water_fee" //查缴水费
import kehuzhongxin from "./pages/kehuzhongxin" //客户中心
import chajiaoshuifei from "./pages/chajiaoshuifei" //查交水费
import yewubanli from "./pages/yewubanli" //业务办理

import yijianbaoxiu from "./pages/yijianbaoxiu.vue" //业务进度查询
import yingyetingyewuyuyue from "./pages/yingyetingyewuyuyue" //营业厅业务预约
import yewujinduchaxun from "./pages/yewujinduchaxun" //一键报修

import regret_pe from "./pages/business_office/regret_pe" //个人报装
import regret from "./pages/business_office/regret" //报装入口
import guohu from "./pages/business_office/guohu" //过户入口
import cbank from "./pages/business_office/cbank" //更改托收银行账号入口
import fyjian from "./pages/business_office/fyjian" //费用减免入口
import baotin from "./pages/business_office/baotin" //报停用水入口
import fapiao from "./pages/business_office/fapiao" //报停用水入口
import baozhuangjindu from "./pages/business_office/baozhuangjindu" //报停用水入口
import huiwa from "./pages/business_office/huiwa" //恢复用水入口
import shuibj from "./pages/business_office/shuibj" //水表检定入口
import hety from "./pages/business_office/hety" //核调用水入口
import shuibk from "./pages/business_office/shuibk" //水表口径变更入口

import shuibqy from "./pages/business_office/shuibqy" //水表迁移
import chaobdh from "./pages/business_office/chaobdh" //抄表到户入口

import gongpgx from "./pages/business_office/gongpgx" //抄表到户入口
import repair from "./pages/repair" //报修
import interactive from "./pages/interactive" //互动留言
import service_guide from "./pages/service_guide" //互动留言

export default [{
        path: '/',
        redirect: 'home_business'
    },
    {
        path: '/home_business',
        component: home
    },
    {
        path: '/gongpgx',
        component: gongpgx
    },
    {
        path: '/businessMenu',
        component: businessMenu
    },
    {
        path: '/customerCenter',
        component: customerCenter
    },
    {
        path: '/waterFee',
        component: waterFee
    },
    {
        path: '/regret',
        component: regret
    },
    {
        path: '/guohu',
        component: guohu
    },
    {
        path: '/cbank',
        component: cbank
    },
    {
        path: '/fyjian',
        component: fyjian
    },
    {
        path: '/baotin',
        component: baotin
    },
    {
        path: '/huiwa',
        component: huiwa
    },
    {
        path: '/shuibj',
        component: shuibj
    },
    {
        path: '/hety',
        component: hety
    },
    {
        path: '/shuibk',
        component: shuibk
    },
    {
        path: '/shuibqy',
        component: shuibqy
    },
    {
        path: '/chaobdh',
        component: chaobdh
    },
    {
        path: '/regret_pe',
        component: regret_pe
    }, {
        path: '/repair',
        component: repair
    },
    {
        path: '/interactive',
        component: interactive
    },
    {
        path: '/service_guide/:active',
        component: service_guide
    },
    {
        path: '/kehuzhongxin',
        component: kehuzhongxin
    },
    {
        path: '/chajiaoshuifei',
        component: chajiaoshuifei
    },
    {
        path: '/yewubanli',
        component: yewubanli
    }
    ,
    {
        path: '/yewujinduchaxun',
        component: yewujinduchaxun
    },
    {
        path: '/yingyetingyewuyuyue',
        component: yingyetingyewuyuyue
    },
    {
        path: '/yijianbaoxiu',
        component: yijianbaoxiu
    },
    {
        path: '/fapiao',
        component: fapiao
    },
    {
        path: '/baozhuangjindu',
        component: baozhuangjindu
    }


]